import { addAddress } from 'shared/models/api';

const EDIT_ADDRESS = 'EDIT_ADDRESS';
const UPDATE_ADDRESS = 'UPDATE_ADDRESS';

const init = {
  addresses: [],
  editingAddress: null
};

export default function reducer(state = init, action = {}) {
  switch (action.type) {
    case EDIT_ADDRESS:
      return { ...state, editingAddress: action.address };
    case UPDATE_ADDRESS:
      return {
        ...state,
        addresses: state.addresses.map(
          address =>
            address.clientId === action.address.clientId
              ? action.address
              : address
        )
      };
    default:
      return state;
  }
}

export function editAddress(address) {
  return dispatch => dispatch({ type: EDIT_ADDRESS, address });
}

export function updateAddress(address) {
  return dispatch => {
    return addAddress(address).then(() => {
      dispatch({ type: UPDATE_ADDRESS, address });
    });
  };
}
